import { SubscriptionModelData } from "@/store/subscriptions/types";
import { OptimisticSyncUpdate, SyncUpdateValue } from "@/store/sync/types";
import { Maybe } from "@/domains/common/types";
import { AppStore } from "@/store/AppStore";
import { PlanId } from "@/store/feature-gates/types";

export type SubscriptionIndexData = {
  space_account_id: string;
  tier: string;
  status: string;
  is_paid: boolean;
};

export class SubscriptionIndexes {
  private store: AppStore;
  private data: SyncUpdateValue<SubscriptionModelData>;

  constructor({
    store,
    remoteData,
    optimisticUpdates,
  }: {
    store: AppStore;
    remoteData: Maybe<SyncUpdateValue<SubscriptionModelData>>;
    optimisticUpdates: OptimisticSyncUpdate<SubscriptionModelData>[];
  }) {
    this.store = store;
    this.data =
      (optimisticUpdates.at(-1)?.value as SyncUpdateValue<SubscriptionModelData>) || remoteData;
  }

  get space_account_id() {
    return this.data.model_data.space_account_id;
  }

  get tier() {
    return this.data.model_data.tier;
  }

  get status() {
    return this.data.model_data.status;
  }

  get is_paid() {
    return this.tier.toLowerCase() === PlanId.Paid;
  }

  get indexes(): SubscriptionIndexData {
    return {
      space_account_id: this.space_account_id,
      tier: this.tier,
      status: this.status,
      is_paid: this.is_paid,
    };
  }
}
